var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagev2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97976 17.5253C12.1046 17.5326 14.2318 16.6406 15.7473 14.8428C18.0148 12.153 18.0861 8.11653 15.9086 5.35352C13.0738 1.75542 7.83788 1.53017 4.70166 4.677C2.40906 6.97654 1.91391 10.3835 3.19839 13.1702C3.30536 13.4377 3.71947 14.1728 3.99743 14.6566C4.15546 14.9315 4.13926 15.2705 3.95691 15.529C3.77376 15.7876 3.542 16.1186 3.36128 16.3902C3.03793 16.8756 3.38154 17.5261 3.9634 17.5253L4.41451 17.5251C6.3931 17.5243 9.29034 17.523 9.97976 17.5253Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9472 10.0006H7.05078M12.9472 10.0006L10.5686 7.62433M12.9472 10.0006L10.5686 12.3771",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagev2);
export default __webpack_public_path__ + "static/media/messagev2.7ac3927a0790d139897b49e4fb6f5df9.svg";
export { ForwardRef as ReactComponent };